"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _vuex = require("vuex");
var _SailScheduleOne = _interopRequireDefault(require("@/components/SailScheduleOne"));
var _blAgreementFr = require("@/api/bookSpace/blAgreementFr");
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _utils = require("@/utils");
var _validate = require("@/utils/validate");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "blAgreementFr",
  components: {
    sailSchedule: _SailScheduleOne.default,
    Pagination: _Pagination.default
  },
  data: function data() {
    return {
      tableLoading: false,
      filterForm: {
        vesselCode: '',
        vesselName: '',
        voyageNo: '',
        voyageLeg: '',
        blNo: '',
        ctnNo: '0',
        appStatus: '0',
        active: '',
        appStatusFt: '0',
        activeFt: '',
        currentPage: 1,
        pageSize: 10
      },
      ctnNoList: [],
      appStatusList: [],
      activeList: [],
      activeListFt: [],
      total: 0,
      tableData: [],
      sailScheduleDialogVisible: false,
      hotSettings: {
        dragCheck: true,
        height: 'calc(100vh - 360px)',
        width: '100%',
        // overflow: 'auto',
        stretchH: 'all',
        manualColumnResize: true,
        language: 'zh-CN',
        licenseKey: '8a4e2-659ac-afa83-14d2e-cb603',
        readOnly: true,
        columnSorting: true,
        showSelection: false,
        fixedColumnsLeft: 1,
        fragmentSelection: 'cell',
        copyPaste: false
      }
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language'])),
  created: function created() {
    var _this = this;
    this.loading = (0, _utils.load)();
    this.$dictionary.get(['BL_AGREEMENT_FR_CTNNO', 'BL_AGREEMENT_FR_APPLY_STATUS', 'BL_AGREEMENT_FR_ACTIVE', 'BL_AGREEMENT_FT_ACTIVE'], true).then(function (res) {
      res = JSON.parse(JSON.stringify(res));
      _this.ctnNoList = res.BL_AGREEMENT_FR_CTNNO ? res.BL_AGREEMENT_FR_CTNNO : [];
      _this.appStatusList = res.BL_AGREEMENT_FR_APPLY_STATUS ? res.BL_AGREEMENT_FR_APPLY_STATUS : [];
      _this.activeList = res.BL_AGREEMENT_FR_ACTIVE ? res.BL_AGREEMENT_FR_ACTIVE : [];
      _this.activeList.unshift({
        displayValue: '',
        displayValueCn: '',
        codeValue: ''
      });
      _this.activeListFt = res.BL_AGREEMENT_FT_ACTIVE ? res.BL_AGREEMENT_FT_ACTIVE : [];
      _this.activeListFt.unshift({
        displayValue: '',
        displayValueCn: '',
        codeValue: ''
      });
    }).finally(function () {
      _this.loading.close();
    });
  },
  mounted: function mounted() {
    var _this2 = this;
    this.$nextTick(function () {
      _this2.resizeHotTable();
      console.log(_this2.tableData, '1111');
    });
  },
  methods: {
    resizeHotTable: function resizeHotTable() {
      this.$refs.hotTable.resizeTo();
    },
    handleOpenVessel: function handleOpenVessel() {
      this.sailScheduleDialogVisible = true;
    },
    selectionChange: function selectionChange(row) {
      this.sailScheduleDialogVisible = false;
      this.filterForm.vesselCode = row.vesselCode;
      this.filterForm.vesselName = row.vesselName;
      this.filterForm.voyageLeg = row.voyageLeg;
      this.filterForm.voyageNo = row.voyageNo;
    },
    handleSearch: function handleSearch() {
      var _this3 = this;
      if (this.filterForm.vesselCode == '' && this.filterForm.voyageNo == '' && this.filterForm.voyageLeg == '' && this.filterForm.blNo == '') {
        this.$message.error(this.$t('booking.blAgreementFr.vesselAndVoyageOrBlNoNotNull'));
        return;
      }
      this.$refs['filterForm'].validate(function (valid) {
        if (valid) {
          _this3.tableLoading = true;
          // this.loading = load()
          (0, _blAgreementFr.queryBlAgreementFr)(_this3.filterForm, {
            currentPage: _this3.filterForm.currentPage,
            pageSize: _this3.filterForm.pageSize
          }).then(function (res) {
            _this3.total = res.data.totalRecord;
            _this3.tableData = res.data.records;
            if (_this3.tableData.length == 0) {
              _this3.hotSettings.height = 'calc(100px)';
              // this.$refs.hotTable.resizeTo()
            }
            _this3.tableLoading = false;
          }).catch(function (err) {}).finally(function () {
            // this.loading.close()
          });
        }
      });
    },
    searchFn: function searchFn(val) {
      this.filterForm.currentPage = val.page;
      this.filterForm.pageSize = val.limit;
      this.handleSearch();
    },
    handleReset: function handleReset() {
      for (var key in this.filterForm) {
        this.filterForm[key] = '';
      }
      this.filterForm.ctnNo = '0';
      this.filterForm.appStatus = '0';
      this.filterForm.appStatusFt = '0';
      this.filterForm.currentPage = 1;
      this.filterForm.pageSize = 10;
    }
  }
};